import React, { useState, useRef } from "react";
import { LoginRegister } from "../LoginRegister";
import { Row } from "reactstrap";
import { Formik, Form, ErrorMessage } from "formik";
import * as Yup from "yup";
import { Verify } from "./Verify";
import { registerApi } from "../../../api";
import { withRouter } from "react-router-dom";
import { Alert, ModalComp } from "../../../shared";
import { PrivacyPolicy, TermsAndConditions } from "../../";
import { useTranslation } from "react-i18next";

const RegisterComp = (props) => {
  const { t, i18n } = useTranslation();
  const [TermsChecked, setTermsChecked] = useState(false);
  const [PrivecyChecked, setPrivecyChecked] = useState(false);
  const [openTermsModal, setOpenTermsModal] = useState(false);
  const toggleTerms = () => setOpenTermsModal(!openTermsModal);
  const [openPrivacyModal, setOpenPrivacyModal] = useState(false);
  const togglePrivacy = () => setOpenPrivacyModal(!openPrivacyModal);
  const [verify, setVerify] = useState(false);
  const form = useRef(null);
  const [showAlert, setShowAlert] = useState({
    show: false,
    message: "",
    type: "",
  });

  const initialLoginValues = {
    name: "",
    mobile: "",
    email: "",
    password: "",
  };

  const submitLoginForm = () => {
    const data = new FormData(form.current);
    registerApi(data)
      .then((res) => {
        props.history.push("/login");
      })
      .catch(() => {
        setShowAlert((prevState) => ({
          ...prevState,
          show: true,
          message: t("این کاربر قبلا ثبت شده است."),
          type: "Error",
        }));
        setTimeout(() => {
          setShowAlert((prevState) => ({
            ...prevState,
            show: false,
          }));
        }, 5000);
      });
    // setVerify(!verify);
  };

  const validationSchemaLogin = Yup.object({
    name: Yup.string().required(() => t("نام و نام خانوادگی را وارد کنید")),
    mobile: Yup.string().required(t("شماره موبایل را وارد کنید")),
    email: Yup.string()
      .required(t("ایمیل را وارد کنید"))
      .email("ایمیل را طبق فرمت وارد کنید."),
    password: Yup.string()
      .required(t("رمز عبور را وارد کنید."))
      .min(3, t("رمز عبور حداقل باید 3 حرف باشد")),
  });

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
  };

  return (
    <LoginRegister>
      <ModalComp
        modal={openTermsModal}
        toggle={toggleTerms}
        component={<TermsAndConditions />}
      />
      <ModalComp
        modal={openPrivacyModal}
        toggle={togglePrivacy}
        component={<PrivacyPolicy />}
      />
      <div className="px-4 pt-5">
        {!verify ? (
          <>
            <Row className="justify-content-center flex-column mb-5">
              <p className="fn12">{t("دسترسی به حساب")}</p>
            </Row>
            <Row className="justify-content-center flex-column">
              <Formik
                initialValues={initialLoginValues}
                onSubmit={submitLoginForm}
                validationSchema={validationSchemaLogin}
              >
                {(props) => (
                  <Form ref={form}>
                    <div className="mb-3">
                      <div className="inputs d-flex flex-column justify-content-center w-100 p-1">
                        {props.values.name && (
                          <p className="fn12 m-0">{t("نام و نام خانوادگی")}</p>
                        )}
                        <input
                          type="text"
                          placeholder={t("نام و نام خانوادگی")}
                          name="name"
                          className="w-100 fn12"
                          onChange={props.handleChange}
                          onBlur={props.handleBlur}
                        />
                      </div>
                      <ErrorMessage name="name">
                        {(errMsg) => (
                          <div className="text-danger fn10 mt-1">{errMsg}</div>
                        )}
                      </ErrorMessage>
                    </div>
                    <div className="mb-3">
                      <div className="inputs d-flex flex-column justify-content-center w-100 p-1">
                        {props.values.mobile && (
                          <p className="fn12 m-0">{t("شماره موبایل")} </p>
                        )}
                        <input
                          type="number"
                          placeholder={t("شماره موبایل")}
                          name="mobile"
                          className="w-100 fn12"
                          onChange={props.handleChange}
                          onBlur={props.handleBlur}
                        />
                      </div>
                      <ErrorMessage name="mobile">
                        {(errMsg) => (
                          <div className="text-danger fn10 mt-1">{errMsg}</div>
                        )}
                      </ErrorMessage>
                    </div>
                    <div className="mb-3">
                      <div className="inputs d-flex flex-column justify-content-center w-100 p-1">
                        {props.values.email && (
                          <p className="fn12 m-0">{t("ایمیل")}</p>
                        )}
                        <input
                          type="email"
                          placeholder={t("ایمیل")}
                          name="email"
                          className="w-100 fn12"
                          onChange={props.handleChange}
                          onBlur={props.handleBlur}
                        />
                      </div>
                      <ErrorMessage name="email">
                        {(errMsg) => (
                          <div className="text-danger fn10 mt-1">{errMsg}</div>
                        )}
                      </ErrorMessage>
                    </div>
                    <div className="mb-3">
                      <div className="inputs d-flex flex-column justify-content-center w-100 p-1">
                        {props.values.password && (
                          <p className="fn12 m-0">{t("رمز عبور")}</p>
                        )}
                        <input
                          type="password"
                          name="password"
                          placeholder={t("رمز عبور")}
                          onChange={props.handleChange}
                          onBlur={props.handleBlur}
                          className="w-100 fn12"
                        />
                      </div>
                      <ErrorMessage name="password">
                        {(errMsg) => (
                          <div className="text-danger fn10 mt-1">{errMsg}</div>
                        )}
                      </ErrorMessage>
                    </div>
                    <div class="form-check fn12">
                      <input
                        onChange={() => setTermsChecked(!TermsChecked)}
                        type="checkbox"
                        class="form-check-input"
                      />
                      <label
                        class="form-check-label mr-3 cursor"
                        onClick={toggleTerms}
                      >
                        {t("با قوانین موافقم")}
                      </label>
                    </div>
                    <div class="form-check fn12">
                      <input
                        onChange={() => setPrivecyChecked(!PrivecyChecked)}
                        type="checkbox"
                        class="form-check-input"
                      />
                      <label
                        class="form-check-label mr-3 cursor"
                        onClick={togglePrivacy}
                      >
                        {t("حریم خصوصی")}
                      </label>
                    </div>
                    <button
                      type="submit"
                      disabled={TermsChecked && PrivecyChecked ? false : true}
                      className="btn btn-primary formBtn mt-4"
                    >
                      {t("ثبت نام")}
                    </button>
                  </Form>
                )}
              </Formik>
            </Row>
          </>
        ) : (
          <Verify />
        )}
      </div>
      {showAlert.show && (
        <Alert message={showAlert.message} type={showAlert.type} />
      )}
    </LoginRegister>
  );
};

const Register = withRouter(RegisterComp);

export { Register };
